import {Lightning} from "@lightningjs/sdk"
import { Base, Button, ButtonSmall, TextBox } from "@lightningjs/ui-components"
import { Helper } from "../../../helper"

export default class EPGProgramUI extends Base {
    [x: string]: any
    _isActive = false
    _isFocused =  false

    static override _template() {
        return  {
            rect:true,
            clipping:true,
            Wrapper: {
                
            }
        }
    }

    static get __componentName(): string {
        return 'EPGProgramUI'
    }

    static get tags() {
        return ['Background', 'Label']
    }

    static get properties() {
        return ['title','index', 'channelIndex']
    }

    _update() {
        //console.log(this._title, this._isActive)
        if(this._isActive) {
            this.tag('Wrapper').patch({
                Background: {
                    w:this.finalW,
                    h:this.finalH,
                    rect:true,
                    color: this._isFocused ? 0xffffffff : 0xff222222,
                    zIndex:1,
                    Stroke: {
                        x: 0,
                        y: 0,
                        w:this.finalW,
                        h:this.finalH,
                        rect: true,
                        color: 0x00000000,
                        shader: {
                            type: Lightning.shaders.RoundedRectangle,
                            radius: 0,
                            stroke: 1,
                            strokeColor: 0x99ffffff
                        }
                    }
                },
                Label : {
                    zIndex:2,
                    type: TextBox,
                    fixed: true,
                    w:this.w-10,
                    content: this._title,
                    style: {
                        offsetX: 10,
                        offsetY: 20,
                        textStyle: {
                            fontSize: 26,
                            fontFace: Helper.getFontFamily('Light'),
                            textColor:this._isFocused ? Helper.getHexaColor('222222') : Helper.getHexaColor('ffffff'),
                            maxLines: 1,
                            maxLinesSuffix: '...'    
                        }
                    }
                }
            })
        } else {
            this.tag('Wrapper').patch({
            })
        }
        
    }

    override getFocusScale() {
        return 1
    }

    override _active(): void {
        this._isActive = true
        this._update()
    }

    override _inactive(): void {
        this._isActive = false
        this._update()
    }

    override _focus(): void {
        this._isFocused = true
        this._update()
        this.fireAncestors('$selectedChange', this)
    }

    override _unfocus(): void {
        this._isFocused = false
        this._update()
    }
}
